export const slgMockData = {
  getSipCreds: JSON.parse('{}'),
  getExtensions: [
    {
      id: '29fe790d-66f7-4154-8556-ab75db025001',
      extensionId: 101,
      userName: 'SalesForce Dev1',
      email: 'salesforcedev1@solgaridev.com',
      server: null,
      port: null,
      tenantId: null,
    },
    {
      id: '29fe790d-66f7-4154-8556-ab75db025002',
      extensionId: 102,
      userName: 'SalesForce Dev2',
      email: 'salesforcedev2@solgaridev.com',
      server: null,
      port: null,
      tenantId: null,
    },
    {
      id: '29fe790d-66f7-4154-8556-ab75db025003',
      extensionId: 103,
      userName: 'SalesForce Dev3',
      email: 'salesforcedev3@solgaridev.com',
      server: null,
      port: null,
      tenantId: null,
    },
    {
      id: '29fe790d-66f7-4154-8556-ab75db025004',
      extensionId: 400,
      userName: 'Alex K',
      email: 'alex.k@pencilpm.io',
      server: null,
      port: null,
      tenantId: null,
    },
    {
      id: '29fe790d-66f7-4154-8556-ab75db025005',
      extensionId: 401,
      userName: 'Alex Melah',
      email: 'alex.m@pencilpm.io',
      server: null,
      port: null,
      tenantId: null,
    },
    {
      id: '29fe790d-66f7-4154-8556-ab75db025006',
      extensionId: 402,
      userName: 'Anatoly Moroving',
      email: 'anatoly.m@pencilpm.io',
      server: null,
      port: null,
      tenantId: null,
    },
    {
      id: '29fe790d-66f7-4154-8556-ab75db025007',
      extensionId: 403,
      userName: 'Andrew Barbarich',
      email: 'andrew.b@pencilpm.io',
      server: null,
      port: null,
      tenantId: null,
    },
    {
      id: '29fe790d-66f7-4154-8556-ab75db025008',
      extensionId: 404,
      userName: 'Artem Rusak',
      email: 'artsiom.r@pencilpm.io',
      server: null,
      port: null,
      tenantId: null,
    },
    {
      id: '29fe790d-66f7-4154-8556-ab75db025009',
      extensionId: 405,
      userName: 'Dmitry Parhots',
      email: 'dmitry.p@pencilpm.io',
      server: null,
      port: null,
      tenantId: null,
    },
    {
      id: '29fe790d-66f7-4154-8556-ab75db025010',
      extensionId: 406,
      userName: 'Andrei Gavrish',
      email: 'andrei.g@pencilpm.io',
      server: null,
      port: null,
      tenantId: null,
    },
  ],
  // getExtensions: [
  //     {
  //         id: '29fe790d-66f7-4154-8556-ab75db025001',
  //         extensionId: 450,
  //         userName: 'marko.marov@solgari.com',
  //         email: 'marko.marov@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '29fe790d-66f7-4154-8556-ab75db025002',
  //         extensionId: 350,
  //         userName: 'ana.ceapa@solgari.com',
  //         email: 'ana.ceapa@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '29fe790d-66f7-4154-8556-ab75db025003',
  //         extensionId: 338901,
  //         userName: 'konrad.cinkusz@solgari.com',
  //         email: 'konrad.cinkusz@solgari.com',
  //         server: '10.4.1.4',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '29fe790d-66f7-4154-8556-ab75db025004',
  //         extensionId: 316,
  //         userName: 'maciej.czestochowski@solgari.com',
  //         email: 'maciej.czestochowski@solgari.com',
  //         server: '10.4.1.4',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '29fe790d-66f7-4154-8556-ab75db025005',
  //         extensionId: 305,
  //         userName: 'marcus.finn@solgari.com',
  //         email: 'marcus.finn@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '29fe790d-66f7-4154-8556-ab75db025006',
  //         extensionId: 340,
  //         userName: 'obi.chinedu@solgari.com',
  //         email: 'obi.chinedu@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '29fe790d-66f7-4154-8556-ab75db0258b5',
  //         extensionId: 329,
  //         userName: 'ppjmcgrath@gmail.com',
  //         email: 'ppjmcgrath@gmail.com',
  //         server: '10.4.1.4',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '2a7b9f35-649d-4083-b8c2-77fb674ee7f3',
  //         extensionId: 401,
  //         userName: 'alex.k@solgari.com',
  //         email: 'alex.k@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '34dfbe81-3df5-4676-bcd2-a005ab522e2a',
  //         extensionId: 328,
  //         userName: 'peter.mcgrath@solgari.com',
  //         email: 'peter.mcgrath@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '4e359f24-98f2-4a8f-8177-d3c34ccf75b8',
  //         extensionId: 406,
  //         userName: 'alexander.vashinko@solgari.com',
  //         email: 'alexander.vashinko@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '7ecf09e6-3b13-4b03-85c9-a460e1533871',
  //         extensionId: 360,
  //         userName: 'angelika.piatkowska@solgari.com',
  //         email: 'angelika.piatkowska@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '88174c2d-96c7-444a-8528-f50aea881ea3',
  //         extensionId: 408,
  //         userName: 'alex.melah@solgari.com',
  //         email: 'alex.melah@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: '9522f637-1f7a-4087-af73-8f4ddca934a3',
  //         extensionId: 403,
  //         userName: 'andrew.b@solgari.com',
  //         email: 'andrew.b@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: 'c3e29856-a2a0-4f6d-93fb-09ae43794b1f',
  //         extensionId: 402,
  //         userName: 'andrei.g@solgari.com',
  //         email: 'andrei.g@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: 'e1c2ee3e-b491-4b0c-8a84-1e4f41664369',
  //         extensionId: 405,
  //         userName: 'anton.kazlouski@solgari.com',
  //         email: 'anton.kazlouski@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  //     {
  //         id: 'ec84e5ff-8a94-4bd6-9521-6ea18c03e93f',
  //         extensionId: 404,
  //         userName: 'artem.r@solgari.com',
  //         email: 'artem.r@solgari.com',
  //         server: 'ucpdev',
  //         port: 5060,
  //         tenantId: 4,
  //     },
  // ],
};
